import { routeList } from '@/router/helpers/routes'
import { validateRouteMandatoryProps } from '@/router/helpers/validations'

export default [{
	path: routeList.CREDITS_BASE_PATH,
	beforeEnter (to, from, next) {
		next(false)
	}
}, {
	path: routeList.CREDITS_MY_CREDITS_PATH,
	name: routeList.CREDITS_MY_CREDITS_NAME,
	component: () => import('@/views/credits/MyCredits')
}, {
	path: routeList.CREDITS_MY_CREDITS_AMORTIZATION_PATH,
	name: routeList.CREDITS_MY_CREDITS_AMORTIZATION_NAME,
	props: true,
	component: () => import('@/views/credits/Amortization'),
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.CREDITS_MY_CREDITS_NAME)
	}
}, {
	path: routeList.CREDITS_SIMULATION_PATH,
	name: routeList.CREDITS_SIMULATION_NAME,
	props: true,
	component: () => import('@/views/credits/Simulation')
}, {
	path: routeList.CREDITS_CREDIT_SOLUTIONS_PATH,
	name: routeList.CREDITS_CREDIT_SOLUTIONS_NAME,
	props: true,
	component: () => import('@/views/credits/CreditSolutions')
}, {
	path: routeList.CREDIT_CREDIT_SOLUTIONS_SUBSCRIBE_PRODUCT_ADIANTAJA_PATH,
	name: routeList.CREDIT_CREDIT_SOLUTIONS_SUBSCRIBE_PRODUCT_ADIANTAJA_NAME,
	props: true,
	component: () => import('@/views/credits/creditProducts/ADIANTAJA'),
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.CREDITS_CREDIT_SOLUTIONS_NAME)
	}
}, {
	path: routeList.CREDITS_CREDIT_SOLUTIONS_SUBSCRIBE_PRODUCT_CC_CP_PATH,
	name: routeList.CREDITS_CREDIT_SOLUTIONS_SUBSCRIBE_PRODUCT_CC_CP_NAME,
	props: true,
	component: () => import('@/views/credits/creditProducts/CCCP'),
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.CREDITS_CREDIT_SOLUTIONS_NAME)
	}
}, {
	path: routeList.CREDITS_CREDIT_SOLUTIONS_COMPARE_CREDIT_SIMULATIONS_PATH,
	name: routeList.CREDITS_CREDIT_SOLUTIONS_COMPARE_CREDIT_SIMULATIONS_NAME,
	props: true,
	component: () => import('@/views/credits/creditProducts/CompareCreditSimulations'),
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.CREDITS_CREDIT_SOLUTIONS_NAME)
	}
}, {
	path: routeList.CREDITS_HISTORY_PATH,
	name: routeList.CREDITS_HISTORY_NAME,
	component: () => import('@/views/UnderDevelopment')
}]
